import { gsap } from '../animations';

/**
 * Animazioni d'ingresso del block "Pillar":
 * - intestazione in fade-up a stagger;
 * - colonne in fade-up a stagger all'ingresso della griglia;
 * - foto con un leggero zoom-out (scale-in) dentro il contenitore in overflow.
 * Con reduced-motion resta tutto fermo e visibile (niente gsap.from).
 */
export function initPillar() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '[data-tm-pillar]' ).forEach( ( block ) => {
		const head = block.querySelector( '[data-tm-pillar-head]' );
		if ( head && head.children.length ) {
			gsap.from( head.children, {
				y: 24,
				opacity: 0,
				duration: 0.7,
				ease: 'power3.out',
				stagger: 0.1,
				scrollTrigger: { trigger: head, start: 'top 84%', once: true },
			} );
		}

		const items = block.querySelectorAll( '[data-tm-pillar-item]' );
		if ( ! items.length ) {
			return;
		}

		const tl = gsap.timeline( {
			scrollTrigger: { trigger: block.querySelector( 'ul' ), start: 'top 80%', once: true },
		} );

		tl.from( items, {
			y: 32,
			opacity: 0,
			duration: 0.7,
			ease: 'power3.out',
			stagger: 0.12,
		} );

		// Foto: leggero zoom-out sincrono col reveal della colonna.
		const imgs = block.querySelectorAll( '[data-tm-pillar-img]' );
		if ( imgs.length ) {
			tl.from(
				imgs,
				{
					scale: 1.08,
					duration: 0.9,
					ease: 'power2.out',
					stagger: 0.12,
				},
				'<'
			);
		}
	} );
}
